import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router';
import { LoginCallback } from '@okta/okta-react';
import PAGES from '../../constants/pages';
import { SigninRequired } from '../../hooks/signinRequired';

const Dashboard = lazy(() => import('../../modules/dashboard'));
const Authentication = lazy(() => import('../../modules/authentication/authentication'));
const ManuellAvstemming = lazy(() => import('../../modules/manuellAvstemming'));
const Logg = lazy(() => import('../../modules/logg'));
const ManuellElimineringMenu = lazy(() => import('../../modules/manuellEliminering'));
const Regler = lazy(() => import('../../modules/regler'));
const Admin = lazy(() => import('../../modules/admin/admin'));
const Kontoplan = lazy(() => import('../../modules/kontoInformasjon'));
const ElimineringOversikt = lazy(() => import('../../modules/elimineringsOversikt'));
const Feiltabell = lazy(() => import('../../modules/feiltabell'));

function Navigation() {
    return (
        <Suspense fallback={<div />}>
            <Routes>
                <Route path={PAGES.AUTHENTICATION} element={<Authentication />} />
                <Route path="/login/callback" element={<LoginCallback />} />
                <Route element={<SigninRequired />}>
                    <Route path={PAGES.DASHBOARD} element={<Dashboard />} />
                    <Route path={PAGES.MANUELL_AVSTEMMING} element={<ManuellAvstemming />} />
                    <Route path={PAGES.ELIMINERING_OVERSIKT} element={<ElimineringOversikt />} />
                    <Route path={PAGES.MANUELL_ELIMINERING} element={<ManuellElimineringMenu />} />
                    <Route path={PAGES.LOGG} element={<Logg />} />
                    <Route path={PAGES.FEILTABELL} element={<Feiltabell />} />
                    <Route path={PAGES.REGLER} element={<Regler />} />
                    <Route path={PAGES.KONTOPLAN} element={<Kontoplan />} />
                    <Route path={PAGES.ADMIN} element={<Admin />} />
                </Route>
                <Route render={() => <Navigate to={PAGES.DASHBOARD} replace />} />
            </Routes>
        </Suspense>
    );
}

export default Navigation;
